import type { Preset } from '@primeuix/themes/types'
import base from './base'
import tag from './tag'
import card from './card'
import chip from './chip'
import dock from './dock'
import knob from './knob'
import menu from './menu'
import tabs from './tabs'
import tree from './tree'
import badge from './badge'
import image from './image'
import panel from './panel'
import toast from './toast'
import avatar from './avatar'
import button from './button'
import dialog from './dialog'
import drawer from './drawer'
import editor from './editor'
import rating from './rating'
import ripple from './ripple'
import select from './select'
import slider from './slider'
import blockui from './blockui'
import divider from './divider'
import inplace from './inplace'
import listbox from './listbox'
import menubar from './menubar'
import message from './message'
import popover from './popover'
import stepper from './stepper'
import toolbar from './toolbar'
import tooltip from './tooltip'
import carousel from './carousel'
import checkbox from './checkbox'
import dataview from './dataview'
import fieldset from './fieldset'
import galleria from './galleria'
import inputotp from './inputotp'
import megamenu from './megamenu'
import password from './password'
import picklist from './picklist'
import skeleton from './skeleton'
import splitter from './splitter'
import terminal from './terminal'
import textarea from './textarea'
import timeline from './timeline'
import accordion from './accordion'
import datatable from './datatable'
import iconfield from './iconfield'
import iftalabel from './iftalabel'
import inputtext from './inputtext'
import orderlist from './orderlist'
import paginator from './paginator'
import panelmenu from './panelmenu'
import speeddial from './speeddial'
import treetable from './treetable'
import breadcrumb from './breadcrumb'
import datepicker from './datepicker'
import fileupload from './fileupload'
import floatlabel from './floatlabel'
import inputgroup from './inputgroup'
import metergroup from './metergroup'
import tieredmenu from './tieredmenu'
import treeselect from './treeselect'
import contextmenu from './contextmenu'
import inputnumber from './inputnumber'
import multiselect from './multiselect'
import progressbar from './progressbar'
import radiobutton from './radiobutton'
import scrollpanel from './scrollpanel'
import splitbutton from './splitbutton'
import autocomplete from './autocomplete'
import confirmpopup from './confirmpopup'
import imagecompare from './imagecompare'
import overlaybadge from './overlaybadge'
import selectbutton from './selectbutton'
import togglebutton from './togglebutton'
import toggleswitch from './toggleswitch'
import cascadeselect from './cascadeselect'
import confirmdialog from './confirmdialog'
import progressspinner from './progressspinner'
import virtualscroller from './virtualscroller'
import organizationchart from './organizationchart'
import extend from './extend'

export default {
    ...base,
    components: {
        tag,
        card,
        chip,
        dock,
        knob,
        menu,
        tabs,
        tree,
        badge,
        image,
        panel,
        toast,
        avatar,
        button,
        dialog,
        drawer,
        editor,
        rating,
        ripple,
        select,
        slider,
        blockui,
        divider,
        inplace,
        listbox,
        menubar,
        message,
        popover,
        stepper,
        toolbar,
        tooltip,
        carousel,
        checkbox,
        dataview,
        fieldset,
        galleria,
        inputotp,
        megamenu,
        password,
        picklist,
        skeleton,
        splitter,
        terminal,
        textarea,
        timeline,
        accordion,
        datatable,
        iconfield,
        iftalabel,
        inputtext,
        orderlist,
        paginator,
        panelmenu,
        speeddial,
        treetable,
        breadcrumb,
        datepicker,
        fileupload,
        floatlabel,
        inputgroup,
        metergroup,
        tieredmenu,
        treeselect,
        contextmenu,
        inputnumber,
        multiselect,
        progressbar,
        radiobutton,
        scrollpanel,
        splitbutton,
        autocomplete,
        confirmpopup,
        imagecompare,
        overlaybadge,
        selectbutton,
        togglebutton,
        toggleswitch,
        cascadeselect,
        confirmdialog,
        progressspinner,
        virtualscroller,
        organizationchart,
    },
    extend,
} satisfies Preset
